// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.branches', {
    url: '/branches',
    templateUrl: 'main/configuration/branches/branches.tpl.html',
    data: { pageTitle: 'Branches' },
  });
};

angular.module('configuration.branches', []).config(config);
